function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgChatIconFilled = function SvgChatIconFilled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M3.778 3C2.796 3 2 3.796 2 4.778V15.597c0 1.584 1.915 2.377 3.035 1.257l1.41-1.41h9.777c.982 0 1.778-.796 1.778-1.777v-8.89C18 3.797 17.204 3 16.222 3H3.778Zm2.586 5.333h7.272c.447 0 .808-.398.808-.889 0-.49-.361-.888-.808-.888H6.364c-.447 0-.808.398-.808.888 0 .491.361.89.808.89ZM10 11.89H6.444a.889.889 0 0 1 0-1.778H10a.889.889 0 0 1 0 1.778Z",
    clipRule: "evenodd"
  }));
};
export default SvgChatIconFilled;